export default __webpack_public_path__ + "static/media/k_series_statistig_item_id.b11818bc.jpg";